import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { AlertDetailsPopover } from '../dataConnectAlerts/AlertDetailsPopover';
import { textCellPadding } from '../dataConnectMultiCluster/DataConnectMultiClusterTableHeaders';
import { ActionItemInfo, ActionItemType, ActionType, MoreActionsMenu } from '../MoreActionsMenu';
import { Alert } from '../types/Alert';
import { Node } from '../types/Node';
import { NodeResUsage } from '../types/NodeResUsage';
import { AcceptClusterNodeButton } from './AcceptClusterNodeButton';
import { ClusterNodeStatus } from './ClusterNodeStatus';
import { DataConnectClusterNodesPresenceIcon } from './DataConnectClusterNodesPresenceIcon';
import { openDeleteClusterNodeDialog } from './DeleteClusterNodeDialog';
import { openRejectClusterNodeDialog } from './RejectClusterNodeDialog';


export type DataConnectClusterNodesTableRowProps = Readonly<{
  node: Node;
  index: number;
  clusterId: string;
  clusterTestId: string;
  nodeResUsage: NodeResUsage;
  nodeAlerts: ReadonlyArray<Alert>;
  allowRejectNode: boolean;
  allowDeleteNode: boolean;
  allowApproveNode: boolean;
  refreshPoolsAndClusters: () => void;
}>;


export function DataConnectClusterNodesTableRow(props: DataConnectClusterNodesTableRowProps) {
  const { node, nodeResUsage, nodeAlerts, index, clusterId, clusterTestId, refreshPoolsAndClusters } = props;
  const cellClass =  textCellPadding +' tb-data-grid-separator-row';

  const targetSelectItem: MenuItemInfo[] = [
    { displayValue: Messages.dataConnectSiteSettingsRejectPoolNodeButton(), value: ActionType.REJECT, disabled: !props.allowRejectNode },
    { displayValue: Messages.deleteMessage(), value: ActionType.DELETE, disabled: !node.allowDelete || !props.allowDeleteNode},
  ];

  return <>
    <td className={cellClass} style={{paddingLeft: 5}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'node-name-cell' + clusterTestId}>
        {node.nodeName}
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 11}}>
      {DataConnectClusterNodesPresenceIcon(node, clusterTestId)}
    </td>
    <td className={cellClass} style={{paddingLeft: 0}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'node-ip-cell' + clusterTestId}>
        <AlertDetailsPopover  alerts={nodeAlerts} />
      </span>
    </td>
    <td className={cellClass} style={{textAlign:'left', paddingLeft: 25 }}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'node-ip-cell' + clusterTestId} style={{paddingLeft: 0}}>
        {node.nodeIp}
      </span>
    </td>
    <td className={cellClass} style={{textAlign: 'right', paddingRight: 12}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'node-ip-cell' + clusterTestId}>
        { (nodeResUsage === undefined || nodeResUsage.cpuCapacity === 0) &&
          <>
          0%
          <span style={{paddingRight:2, paddingLeft:2}}>({'0 Core'})</span>
          </>
        }
        { nodeResUsage !== undefined && nodeResUsage.cpuCapacity !== 0 &&
          <>
          {(nodeResUsage.cpuAllocated/nodeResUsage.cpuCapacity * 100).toFixed(2)}%
          <span style={{paddingRight:2, paddingLeft:2}}>({(nodeResUsage.cpuAllocated/1000).toFixed(2) +' Cores'})</span>
          </>
        }
      </span>
    </td>
    <td className={cellClass} style={{textAlign: 'right', paddingRight: 12}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'node-ip-cell' + clusterTestId}>
        { (nodeResUsage === undefined || nodeResUsage.memoryCapacityKb === 0) &&
          <>
          0%
          <span style={{paddingRight:2, paddingLeft:2}}>({'0 GB'})</span>
          </>
        }
        { nodeResUsage !== undefined && nodeResUsage.memoryCapacityKb !== 0 &&
          <>
          {(nodeResUsage.memoryAllocatedKb/nodeResUsage.memoryCapacityKb * 100).toFixed(2)}%
          <span style={{paddingRight:2, paddingLeft:2}}>({(nodeResUsage.memoryAllocatedKb/1024/1024/1024).toFixed(1) +' GB'})</span>
          </>
        }
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 15}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'node-actions-cell' + clusterTestId}>
        {
        showAcceptNodeButton(node) ? <AcceptClusterNodeButton
          node={node}
          index={index}
          clusterId={clusterId}
          disabled={props.allowApproveNode}
          refreshBaasEdgePools= {refreshPoolsAndClusters}
        /> : <></>
        }

        <MoreActionsMenu
          targetItemInfo={targetSelectItem}
          actionType= {ActionItemType.NODE_ACTION}
          actionItemInfo={{nodeId: node.nodeId, nodeName: node.nodeName,
                      clusterId: clusterId,
                      refreshPoolsAndClusters: refreshPoolsAndClusters }}
          onHandleMenuSelect={onHandleMenuSelect}
        />
       </span>
    </td>
  </>;
}

const showAcceptNodeButton = (node: Node) =>{
  if(node.nodeStatus === ClusterNodeStatus.UNACCEPTED) {
      return true;
  }
  return false;
};


const onHandleMenuSelect = (actionItem: ActionItemInfo, actionType: string) => {
    if (actionType === ActionType.REJECT) {
      openRejectClusterNodeDialog(actionItem);
    } else if (actionType === ActionType.DELETE) {
      openDeleteClusterNodeDialog(actionItem);
    }

};
